import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getLandingGeneralSettings = () =>
  axiosInstance.get(`${LANDING_API_URL}/setting/landing-general-settings`, {
    headers: authHeaders(),
  });

export const updateLandingGeneralSettingsRequest = (formData) =>
  axiosInstance.post(
    `${LANDING_API_URL}/setting/landing-general-settings`,
    formData,
    {
      headers: authHeaders({ "Content-Type": "multipart/form-data" }),
    },
  );
